import NotifyingError from './NotifyingError';

class SnapshotOutOfBoundsError extends NotifyingError {
  constructor(message) {
    const errorMessage = message || 'The snapshot feature for this live cam is not currently working. Our staff has been notified. Please try again later.';
    super(errorMessage);
  }
}

export default SnapshotOutOfBoundsError;
